export class Config {

    static urlserveur = 'https://app.optimumdigital.academy';
    // static urlserveur = 'http://127.0.0.1:8000';

    static urlserveuravecslash = Config.urlserveur + '/';

    static apiUrl= Config.urlserveur + '/api/';
    static urlmediatheque = '/bundles/sadevdefault/vendors/mediatheque/index.php';

 }